import React from "react";
import { Link } from "react-router-dom";
import { Translate, I18n } from "react-redux-i18n";
import { connect } from "react-redux";

import "./styles/TransactionList.css";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

import ModalGodiwayer from "../components/ModalGodiwayer";
import ModalCalification from "../components/ModalCalification";
import ModalTransactionAddress from "../components/ModalTransactionAddress";
import TransactionUserChip from "../components/TransactionUserChip";
import * as actions_contact from "../redux/actions/contactsActions";
import MiniLoader from "./MiniLoader";

function getStatusClass(status) {
  if (status === "FINISHED") return "transaction-card__status--finished";
  return "transaction-card__status--pending";
}

class TransactionItem extends React.Component {
  render() {
    const { item, userRoleLabel } = this.props;
    const showRating =
      item.Status !== "FINISHED" && item.CalificationSeller === null;

    return (
      <article className="transaction-card">
        <Link
          to={`/goder/show/${item.Ad.Id}`}
          className="transaction-card__media"
        >
          <img
            className="transaction-card__img"
            src={item.Ad.Photo}
            alt={item.Ad.Name}
          />
          {item.KindCommerceId != null && (
            <span className="transaction-card__kind">
              <Translate value={"kind_commerce" + item.KindCommerceId} />
            </span>
          )}
        </Link>

        <div className="transaction-card__body">
          <div className="transaction-card__header">
            <h3 className="transaction-card__title">
              <Link to={`/goder/show/${item.Ad.Id}`}>{item.Ad.Name}</Link>
            </h3>
            <span
              className={`transaction-card__status ${getStatusClass(item.Status)}`}
            >
              {item.Status}
            </span>
          </div>

          <dl className="transaction-card__meta">
            <div className="transaction-card__meta-row">
              <dt>
                <Translate value="transaction_date" />
              </dt>
              <dd>{item.CreatedAt}</dd>
            </div>
            <div className="transaction-card__meta-row">
              <dt>
                <Translate value="transaction_quantity" />
              </dt>
              <dd>{item.Quantity}</dd>
            </div>
          </dl>

          <TransactionUserChip
            user={item.User}
            roleLabel={userRoleLabel}
            onOpenProfile={this.props.onOpenProfile}
            onClickChat={this.props.onClickChat}
            transactionId={"GW-T" + item.Id}
            onViewAddress={this.props.onViewAddress}
            onViewCalification={
              showRating ? this.props.onViewCalification : null
            }
          />
        </div>
      </article>
    );
  }
}

class TransactionList extends React.Component {
  state = {
    open_modal_calification: false,
    open_modal_profile: false,
    open_modal_address: false,
    transaction: {},
    contact: {},
    country: {},
    address: null,
  };

  onClickViewProfile = (user, country = {}) => {
    this.setState({
      open_modal_profile: true,
      contact: user,
      country,
    });
  };

  onCloseModalProfile = () => {
    this.setState({ open_modal_profile: false });
  };

  onCloseModalCalification = () => {
    this.setState({ open_modal_calification: false });
  };

  onViewAddress = (item) => {
    this.setState({ open_modal_address: true, address: item.Address });
  };

  onCloseModalAddress = () => {
    this.setState({ open_modal_address: false });
  };

  onClickChat = (item) => {
    this.props.SetContact(item.User);
  };

  onViewCalification = (item) => {
    this.setState({
      open_modal_calification: true,
      transaction: item,
    });
  };

  render() {
    if (
      this.props.pageCount === 0 ||
      this.props.transactionList.length === 0
    ) {
      return (
        <div className="transaction-list__empty">
          <Translate value="transaction_not_list" />
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="transaction-list">
          {this.props.transactionList.map((item) => (
            <TransactionItem
              item={item}
              key={item.Id.toString()}
              userRoleLabel={<Translate value="transaction_buyer" />}
              onOpenProfile={(user) => this.onClickViewProfile(user, item.Country)}
              onViewAddress={() => {
                this.onViewAddress(item);
              }}
              onClickChat={() => {
                this.onClickChat(item);
              }}
              onViewCalification={() => {
                this.onViewCalification(item);
              }}
            />
          ))}
        </div>

        {this.props.pageSize >= 4 &&
          (this.props.loadingMore ? (
            <div className="transaction-list__load-more">
              <MiniLoader />
            </div>
          ) : (
            <div className="transaction-list__load-more">
              <button
                type="button"
                className="transaction-list__load-more-btn"
                onClick={() => {
                  this.props.onClickLoadMore();
                }}
              >
                <Translate value="load_more" />
              </button>
            </div>
          ))}

        <ModalGodiwayer
          isOpen={this.state.open_modal_profile}
          onClose={() => {
            this.onCloseModalProfile();
          }}
          item={this.state.contact}
          country={this.state.country}
          identityOnly
          showChatAction={false}
        />
        <ModalCalification
          isOpen={this.state.open_modal_calification}
          onClose={() => {
            this.onCloseModalCalification();
          }}
          transaction={this.state.transaction}
        />
        <ModalTransactionAddress
          isOpen={this.state.open_modal_address}
          onClose={this.onCloseModalAddress}
          address={this.state.address}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  SetContact: (item) => dispatch(actions_contact.setContact(item)),
});

export default connect(null, mapDispatchToProps)(TransactionList);
